<div class="modal-header">
  <h5 class="modal-title" i18n="@@PrintInvoiceHeader">Rechnung
    <strong class="skeleton text" *ngIf="invoice == null">____-____-________</strong>
    <strong *ngIf="invoice != null">{{ invoice.invoiceNumber }}</strong>
  </h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <h6 i18n="@@FileNameHeader">Dateiname:</h6>
  
  <div class="skeleton input" *ngIf="invoice == null">&nbsp;</div>
  <input *ngIf="invoice != null" id="filename" type="text" [value]="filename" class="form-control" disabled>

  <div class="filename-scheme">
    <div class="skeleton input" *ngIf="invoice == null">&nbsp;</div>
    <select *ngIf="invoice != null" [(ngModel)]="filenameFirstVariable"
      id="filenameFirstVariable" class="form-select" (change)="setFilename()">
      <option value="invoiceNumber" [selected]="true" i18n="@@InvoiceNumber">Rechnungsnummer</option>
      <option value="ownerFullName" i18n="@@OwnerFullName">Aussteller</option>
      <option value="recipientFullName" i18n="@@RecipientFullName">Empfänger</option>
      <option value="recipientCompany" *ngIf="invoice.recipientCompany" i18n="@@Company">Firma</option>
      <option value="createdAt" i18n="@@CreatedDate">Ausstellungsdatum</option>
      <option value="dueAt" *ngIf="invoice.dueAt" i18n="@@DueDate">Fälligkeitsdatum</option>
    </select>

    <div class="skeleton input" *ngIf="invoice == null">&nbsp;</div>
    <select *ngIf="invoice != null" [(ngModel)]="filenameSecondVariable"
      id="filenameSecondVariable" class="form-select" (change)="setFilename()">
      <option value=""></option>
      <option value="invoiceNumber" i18n="@@InvoiceNumber">Rechnungsnummer</option>
      <option value="ownerFullName" i18n="@@OwnerFullName">Aussteller</option>
      <option value="recipientFullName" i18n="@@RecipientFullName">Empfänger</option>
      <option value="recipientCompany" *ngIf="invoice.recipientCompany" i18n="@@Company">Firma</option>
      <option value="createdAt" i18n="@@CreatedDate">Ausstellungsdatum</option>
      <option value="dueAt" *ngIf="invoice.dueAt" i18n="@@DueDate">Fälligkeitsdatum</option>
    </select>

    <div class="skeleton input" *ngIf="invoice == null">&nbsp;</div>
    <select *ngIf="invoice != null" [(ngModel)]="filenameThirdVariable"
      id="filenameThirdVariable" class="form-select" (change)="setFilename()">
      <option value=""></option>
      <option value="invoiceNumber" i18n="@@InvoiceNumber">Rechnungsnummer</option>
      <option value="ownerFullName" i18n="@@OwnerFullName">Aussteller</option>
      <option value="recipientFullName" i18n="@@RecipientFullName">Empfänger</option>
      <option value="recipientCompany" *ngIf="invoice.recipientCompany" i18n="@@Company">Firma</option>
      <option value="createdAt" i18n="@@CreatedDate">Ausstellungsdatum</option>
      <option value="dueAt" *ngIf="invoice.dueAt" i18n="@@DueDate">Fälligkeitsdatum</option>
    </select>
  </div>
</div>

<div class="modal-footer">
  <div class="float-end">
    <button type="button" class="btn btn-yellow text-white me-1" data-bs-dismiss="modal" (click)="close()" i18n="@@CancelButton">
      Abbrechen
    </button>
    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="downloadAsPDF()" i18n="@@DownloadButton">
      Herunterladen
    </button>
  </div>
</div>
